module.exports = __webpack_public_path__ + "img/icon-close.357b68d5.svg";